
export const _genHash = (len) => {
    let arr = "1234567890abcdefghijklmnopqrstuvwxyz";
    var ans = "";
    for (var i = len; i > 0; i--) {
      ans += arr[Math.floor(Math.random() * arr.length)];
    }
    return ans;
  };